import type { SupervisorAuditSampleItem } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';
import { FINDING_SEVERITY_COLOR, FINDING_STATUS_COLOR } from '../../lib/findingStatusColor';
import { formatValue } from '../../lib/formatValue';
import { AuditExtractedRow } from './AuditExtractedRow';
import { verdictLine } from './auditPresentation';

/** Right-hand panel: check, reason, extracted row, old and proposed values, and the judge verdict. */
export function AuditFindingPanel({ item }: { item: SupervisorAuditSampleItem }) {
  const f = item.finding;
  const cited = item.latestAttempt?.citedText ?? null;
  return (
    <div className="space-y-4 rounded-lg border border-gray-200 bg-white p-4 shadow dark:border-zinc-700 dark:bg-zinc-800 dark:shadow-zinc-950/30">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-sm font-medium text-gray-900 dark:text-zinc-100">{f.checkId}</h2>
        <Badge color={FINDING_SEVERITY_COLOR[f.severity]}>{f.severity}</Badge>
        <Badge color={FINDING_STATUS_COLOR[f.status]}>{f.status}</Badge>
        <Badge color="zinc">{item.documentCategory}</Badge>
      </div>
      <p className="text-sm text-gray-700 dark:text-zinc-300">{f.reason}</p>
      <AuditExtractedRow row={item.extractedRow} rowMoved={item.rowMoved} field={f.field} />
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
        <dt className="text-gray-500 dark:text-zinc-400">Field</dt>
        <dd className="font-mono text-gray-900 dark:text-zinc-100">{f.field}</dd>
        <dt className="text-gray-500 dark:text-zinc-400">Old value</dt>
        <dd className="break-all text-gray-900 dark:text-zinc-100">{formatValue(f.oldValue)}</dd>
        <dt className="text-gray-500 dark:text-zinc-400">Proposed value</dt>
        <dd className="break-all text-gray-900 dark:text-zinc-100">{f.hasProposal ? formatValue(f.newValue) : 'no proposal'}</dd>
        <dt className="text-gray-500 dark:text-zinc-400">Judge</dt>
        <dd className="text-gray-900 dark:text-zinc-100">{verdictLine(item)}</dd>
        {cited && (
          <>
            <dt className="text-gray-500 dark:text-zinc-400">Cited text</dt>
            <dd className="italic text-gray-900 dark:text-zinc-100">“{cited}”</dd>
          </>
        )}
      </dl>
    </div>
  );
}
